import { PropsWithChildren, ReactElement } from 'react';
import { Flex } from '@atlaskit/primitives';
import { ErrorBoundary } from 'react-error-boundary';
import { GraphQLConnectionError } from '#definitions/graphql';
import SectionMessage from '@atlaskit/section-message';

export const GraphQLNotConnectedFallback = ({
  children,
  errorText,
}: PropsWithChildren<{ errorText: string }>) => (
  <GraphQLNotConnectedBoundary
    fallback={
      <Flex alignItems="center" justifyContent="center">
        <div style={{ flex: 1 }}>
          <SectionMessage appearance="error" title={errorText}>
            Failed to load GraphQL
          </SectionMessage>
        </div>
      </Flex>
    }
  >
    {children}
  </GraphQLNotConnectedBoundary>
);

export function GraphQLNotConnectedBoundary({
  children,
  fallback,
}: PropsWithChildren<{ fallback: ReactElement }>) {
  return (
    <ErrorBoundary
      fallbackRender={(error) => {
        if (!(error.error instanceof GraphQLConnectionError)) {
          console.log(
            'Not a graphql connection error, throwing up',
            error.error,
          );
          throw error.error;
        }
        return fallback;
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
